import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  LangDefinition,
  provideTransloco,
  Translation,
  TRANSLOCO_LOADER,
  TranslocoLoader,
} from '@ngneat/transloco';
import { provideTranslocoPersistLang } from '@ngneat/transloco-persist-lang';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

interface TranslocoRootModuleConfig {
  languages: LangDefinition[];
  prodMode: boolean;
}

export const provideCustomTransloco = ({
  languages,
  prodMode,
}: TranslocoRootModuleConfig) => {
  return [
    provideTransloco({
      config: {
        availableLangs: languages,
        defaultLang: 'en',
        fallbackLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: prodMode,
        missingHandler: {
          logMissingKey: true,
          // It will use the first language set in the `fallbackLang` property
          useFallbackTranslation: prodMode,
        },
      },
      // loader: TranslocoHttpLoader,
    }),
    provideTranslocoPersistLang({
      storage: {
        useValue: localStorage,
      },
    }),
    // ...(prodMode
    //   ? [
    //       provideTranslocoPersistTranslations({
    //         loader: TranslocoHttpLoader,
    //         storage: { useValue: localStorage },
    //       }),
    //     ]
    //   : []),
    { provide: TRANSLOCO_LOADER, useExisting: TranslocoHttpLoader },
  ];
};
